<template>
    <div class="permission-view" v-loading="loading">
        
        <div class="row">
            <div class="col-md-12">

                <el-form ref="userRoleSelection" :model="page.form" label-width="150px">

                    <el-form-item label="Select Role">
                        <el-autocomplete
                            v-model="page.form.roleSelection.role"
                            :fetch-suggestions="roleSearch"
                            placeholder="Please Input"
                            @select="roleSelect"
                        ></el-autocomplete>
                    </el-form-item>

                </el-form>

            </div>
        </div>

        <div class="row">
            <div class="col-md-12">

                <p>Permissions</p>

                <table style="width: 100%" class="table table-responsive-sm">
                    <thead class="thead-dark">
                        <tr>
                            <th>Permissions</th>
                            <th>View</th>
                            <th>Add</th>
                            <th>Edit</th>
                            <th>Delete</th>
                            <th>Switch</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            <th>About</th>
                            <td><el-checkbox v-model="page.form.permission.about.view"></el-checkbox></td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                        </tr>

                        <tr>
                            <th>Testimonial</th>
                            <td><el-checkbox v-model="page.form.permission.testimonial.view"></el-checkbox></td>
                            <td><el-checkbox v-model="page.form.permission.testimonial.add"></el-checkbox></td>
                            <td><el-checkbox v-model="page.form.permission.testimonial.edit"></el-checkbox></td>
                            <td><el-checkbox v-model="page.form.permission.testimonial.delete"></el-checkbox></td>
                            <td><el-checkbox v-model="page.form.permission.testimonial.switch"></el-checkbox></td>
                        </tr>

                        <tr>
                            <th>Website Info</th>
                            <td>-</td>
                            <td>-</td>
                            <td><el-checkbox v-model="page.form.permission.website_info.information"></el-checkbox></td>
                            <td>-</td>
                            <td>-</td>
                        </tr>

                        <tr>
                            <th>Bank Details</th>
                            <td>-</td>
                            <td>-</td>
                            <td><el-checkbox v-model="page.form.permission.website_info.bank_details"></el-checkbox></td>
                            <td>-</td>
                            <td>-</td>
                        </tr>

                        <tr>
                            <th>Social Media URL</th>
                            <td>-</td>
                            <td>-</td>
                            <td><el-checkbox v-model="page.form.permission.website_info.social_media_url"></el-checkbox></td>
                            <td>-</td>
                            <td>-</td>
                        </tr>                    

                        <tr>
                            <th>Online Application</th>
                            <td><el-checkbox v-model="page.form.permission.online_application.view"></el-checkbox></td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td><el-checkbox v-model="page.form.permission.online_application.switch"></el-checkbox></td>
                        </tr>

                        <tr>
                            <th>Course</th>
                            <td><el-checkbox v-model="page.form.permission.course.view"></el-checkbox></td>
                            <td><el-checkbox v-model="page.form.permission.course.add"></el-checkbox></td>
                            <td><el-checkbox v-model="page.form.permission.course.edit"></el-checkbox></td>
                            <td><el-checkbox v-model="page.form.permission.course.delete"></el-checkbox></td>
                            <td>-</td>
                        </tr>

                        <tr>
                            <th>Special Program</th>
                            <td><el-checkbox v-model="page.form.permission.special_program.view"></el-checkbox></td>
                            <td><el-checkbox v-model="page.form.permission.special_program.add"></el-checkbox></td>
                            <td><el-checkbox v-model="page.form.permission.special_program.edit"></el-checkbox></td>
                            <td><el-checkbox v-model="page.form.permission.special_program.delete"></el-checkbox></td>
                            <td>-</td>
                        </tr>

                        <tr>
                            <th>Events</th>
                            <td><el-checkbox v-model="page.form.permission.event.view"></el-checkbox></td>
                            <td><el-checkbox v-model="page.form.permission.event.add"></el-checkbox></td>
                            <td><el-checkbox v-model="page.form.permission.event.edit"></el-checkbox></td>
                            <td><el-checkbox v-model="page.form.permission.event.delete"></el-checkbox></td>
                            <td><el-checkbox v-model="page.form.permission.event.switch"></el-checkbox></td>
                        </tr>

                        <tr>
                            <th>User</th>
                            <td><el-checkbox v-model="page.form.permission.user.view"></el-checkbox></td>
                            <td><el-checkbox v-model="page.form.permission.user.add"></el-checkbox></td>
                            <td><el-checkbox v-model="page.form.permission.user.edit"></el-checkbox></td>
                            <td><el-checkbox v-model="page.form.permission.user.delete"></el-checkbox></td>
                            <td>-</td>
                        </tr>

                        <tr>
                            <th>User Role</th>
                            <td><el-checkbox v-model="page.form.permission.user_role.view"></el-checkbox></td>
                            <td><el-checkbox v-model="page.form.permission.user_role.add"></el-checkbox></td>
                            <td><el-checkbox v-model="page.form.permission.user_role.edit"></el-checkbox></td>
                            <td><el-checkbox v-model="page.form.permission.user_role.delete"></el-checkbox></td>
                            <td>-</td>
                        </tr>

                        <tr>
                            <th>User Rights</th>
                            <td><el-checkbox v-model="page.form.permission.user_rights.view"></el-checkbox></td>
                            <td>-</td>
                            <td><el-checkbox v-model="page.form.permission.user_rights.edit"></el-checkbox></td>
                            <td>-</td>
                            <td>-</td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <el-button type="primary" @click="updateRights">Update Rights</el-button>
            </div>
        </div>

    </div>
</template>

<script>
import {generateHeader} from "@/misc/function.js";
export default {
    data() {
        return {
            loading: true,
            rights: {
                page: true,
                edit: false
            },
            page: {
                form: {
                    roleSelection: {
                        user_role: [],
                        role: '',
                        r_id: ''
                    },
                    permission: {
                        about: {
                            page: false,
                            view: false
                        },
                        testimonial: {
                            page: false,
                            switch: false,
                            add: false,
                            edit: false,
                            view: false,
                            delete: false
                        },
                        website_info: {
                            page: false,
                            information: false,
                            bank_details: false,
                            social_media_url: false
                        },
                        online_application: {
                            page: false,
                            switch: false,
                            view: false
                        },
                        course: {
                            page: false,
                            add: false,
                            edit: false,
                            view: false,
                            delete: false
                        },
                        special_program: {
                            page: false,
                            add: false,
                            edit: false,
                            view: false,
                            delete: false
                        },
                        event: {
                            page: false,
                            switch: false,
                            add: false,
                            edit: false,
                            view: false,
                            delete: false
                        },
                        user: {
                            page: false,
                            add: false,
                            edit: false,
                            view: false,
                            delete: false
                        },
                        user_role: {
                            page: false,
                            add: false,
                            edit: false,
                            view: false,
                            delete: false
                        },
                        user_rights: {
                            page: false,
                            view: false,
                            edit: false
                        }
                    }
                }
            }
        }
    },
    methods: {
        createFilter(queryString) {
            return (link) => {
            return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },
        roleSearch(queryString, cb) {
            var links = this.page.form.roleSelection.user_role;
            var results = queryString ? links.filter(this.createFilter(queryString)) : links;
            // call callback function to return suggestions
            cb(results);
        },
        roleSelect(item) {
            this.page.form.roleSelection.r_id = item.link
            this.getData()
        },
        getRights() {
            this.loading = true
            this.$axios.post('user-rights/rights.php' , {} , {
                headers: generateHeader("userRights")
            })
            .then((response) => {
                if(response.data.code == "200"){
                    //Whole Page Right
                    this.rights.page = response.data.body.rights.user_rights_page == 1 ? true : false
                    // Rights
                    this.rights.edit = response.data.body.rights.user_rights_edit == 1 ? true : false

                    this.getRole();
                }
                else if(response.data.code == "403"){
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                    this.$router.push('/admin/dashboard')
                }
                else if (response.data.code == "401"){
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                    localStorage.clear()
                    this.$router.push('/login')
                }
                else{
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                }
                this.loading = false
            })
            .catch((error) => {
                this.$notify.error({
                    title: 'Error',
                    message: error
                });
                this.loading = false
            })
        },
        getRole() {
            this.loading = true
            this.$axios.post("user-role/get.php" , {
                pageSize: 0,
                page: 0
            },{
                headers: generateHeader("userRoleData")
            })
            .then((response) => {
                if(response.data.code == "200"){
                    for(var i =0 ; i< response.data.extra.totalData; i++){
                        this.page.form.roleSelection.user_role.push({
                            "value":response.data.body[i].user_role , "link": response.data.body[i].r_id
                        })
                    }
                }
                else if(response.data.code == "404"){
                    // this.table.tableData = []
                    // this.pagination.totalData = 0
                }
                else if (response.data.code == "401"){
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                    localStorage.clear()
                    this.$router.push('/login')
                }
                else{
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                }
                this.loading = false
            })
            .catch((error) => {
                this.$notify.error({
                    title: 'Error',
                    message: error
                });
                this.loading = false
            })
        },
        assignCheckValue(field){
            return field == 1 ? true : false
        },
        getData(){
            this.loading = true
            this.$axios.post("user-rights/get.php" , {
                id: this.page.form.roleSelection.r_id 
            },{
                headers: generateHeader("userRightsData")
            })
            .then((response) => {
                if(response.data.code == "200"){
                    //About
                    this.page.form.permission.about.page = this.assignCheckValue(response.data.body.about_page)
                    if(this.page.form.permission.about.page){
                        this.page.form.permission.about.view = true
                    }
                    else{
                        this.page.form.permission.about.view = false
                    }

                    //Testimonial
                    this.page.form.permission.testimonial.page = this.assignCheckValue(response.data.body.testimonial_page)
                    this.page.form.permission.testimonial.view = this.assignCheckValue(response.data.body.testimonial_view)
                    this.page.form.permission.testimonial.add = this.assignCheckValue(response.data.body.testimonial_add)
                    this.page.form.permission.testimonial.edit = this.assignCheckValue(response.data.body.testimonial_edit)
                    this.page.form.permission.testimonial.delete = this.assignCheckValue(response.data.body.testimonial_delete)
                    this.page.form.permission.testimonial.switch = this.assignCheckValue(response.data.body.testimonial_switch)

                    //website Info
                    this.page.form.permission.website_info.information = this.assignCheckValue(response.data.body.information)
                    this.page.form.permission.website_info.bank_details = this.assignCheckValue(response.data.body.bank_details)
                    this.page.form.permission.website_info.social_media_url = this.assignCheckValue(response.data.body.social_media_url)
                    this.page.form.permission.website_info.page = this.assignCheckValue(response.data.body.website_info_page)

                    //Online Application
                    this.page.form.permission.online_application.page = this.assignCheckValue(response.data.body.online_application_page)
                    this.page.form.permission.online_application.view = this.assignCheckValue(response.data.body.online_application_view)
                    this.page.form.permission.online_application.switch =this.assignCheckValue(response.data.body.online_application_switch)

                    //Course
                    this.page.form.permission.course.page = this.assignCheckValue(response.data.body.course_page)
                    this.page.form.permission.course.view = this.assignCheckValue(response.data.body.course_view)
                    this.page.form.permission.course.add = this.assignCheckValue(response.data.body.course_add)
                    this.page.form.permission.course.edit = this.assignCheckValue(response.data.body.course_edit)
                    this.page.form.permission.course.delete = this.assignCheckValue(response.data.body.course_delete)

                    //special Permission
                    this.page.form.permission.special_program.page = this.assignCheckValue(response.data.body.special_program_page)
                    this.page.form.permission.special_program.view = this.assignCheckValue(response.data.body.special_program_view)
                    this.page.form.permission.special_program.add = this.assignCheckValue(response.data.body.special_program_add)
                    this.page.form.permission.special_program.edit = this.assignCheckValue(response.data.body.special_program_edit)
                    this.page.form.permission.special_program.delete = this.assignCheckValue(response.data.body.special_program_delete)

                    //Events
                    this.page.form.permission.event.page = this.assignCheckValue(response.data.body.event_page)
                    this.page.form.permission.event.view = this.assignCheckValue(response.data.body.event_view)
                    this.page.form.permission.event.add = this.assignCheckValue(response.data.body.event_add)
                    this.page.form.permission.event.edit = this.assignCheckValue(response.data.body.event_edit)
                    this.page.form.permission.event.delete = this.assignCheckValue(response.data.body.event_delete)
                    this.page.form.permission.event.switch = this.assignCheckValue(response.data.body.event_switch)

                    //User
                    this.page.form.permission.user.page = this.assignCheckValue(response.data.body.user_page)
                    this.page.form.permission.user.view = this.assignCheckValue(response.data.body.user_view)
                    this.page.form.permission.user.add = this.assignCheckValue(response.data.body.user_add)
                    this.page.form.permission.user.edit = this.assignCheckValue(response.data.body.user_edit)
                    this.page.form.permission.user.delete = this.assignCheckValue(response.data.body.user_delete)
                    
                    //User Role
                    this.page.form.permission.user_role.page = this.assignCheckValue(response.data.body.user_role_page)
                    this.page.form.permission.user_role.view = this.assignCheckValue(response.data.body.user_role_view)
                    this.page.form.permission.user_role.add = this.assignCheckValue(response.data.body.user_role_add)
                    this.page.form.permission.user_role.edit = this.assignCheckValue(response.data.body.user_role_edit)
                    this.page.form.permission.user_role.delete = this.assignCheckValue(response.data.body.user_role_delete)

                    //User Rights
                    this.page.form.permission.user_rights.page = this.assignCheckValue(response.data.body.user_rights_page)
                    this.page.form.permission.user_rights.edit =  this.assignCheckValue(response.data.body.user_rights_edit)
                    if(this.page.form.permission.user_rights.page){
                        this.page.form.permission.user_rights.view = true
                    }
                    else{
                        this.page.form.permission.user_rights.view = false
                    }

                }
                else if(response.data.code == "404"){
                    
                }
                else if (response.data.code == "401"){
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                    localStorage.clear()
                    this.$router.push('/login')
                }
                else{
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                }
                this.loading = false
            })
            .catch((error) => {
                this.$notify.error({
                    title: 'Error',
                    message: error
                });
                this.loading = false
            })
        },
        updateRights(){
            //About
            if(this.page.form.permission.about.view){
                this.page.form.permission.about.page = true
            }
            else{
                this.page.form.permission.about.page = false
            }

            //Website Info
            if(this.page.form.permission.website_info.information || this.page.form.permission.website_info.bank_details || this.page.form.permission.website_info.social_media_url){
                this.page.form.permission.website_info.page = true
            }
            else{
                this.page.form.permission.website_info.page = false
            }

            //Testimonial
            if(
                this.page.form.permission.testimonial.view ||
                this.page.form.permission.testimonial.add ||
                this.page.form.permission.testimonial.edit ||
                this.page.form.permission.testimonial.delete ||
                this.page.form.permission.testimonial.switch
            ){
                this.page.form.permission.testimonial.page = true
            }
            else{
                this.page.form.permission.testimonial.page = false
            }

            //Online Application
            if(
                this.page.form.permission.online_application.view ||
                this.page.form.permission.online_application.switch
            ){
                this.page.form.permission.online_application.page = true
            }
            else{
                this.page.form.permission.online_application.page = false
            }

            //Course
            if(
                this.page.form.permission.course.view ||
                this.page.form.permission.course.add ||
                this.page.form.permission.course.edit ||
                this.page.form.permission.course.delete
            ){
                this.page.form.permission.course.page = true
            }
            else{
                this.page.form.permission.course.page = false
            }

            //Special Program
            if(
                this.page.form.permission.special_program.view ||
                this.page.form.permission.special_program.add ||
                this.page.form.permission.special_program.edit ||
                this.page.form.permission.special_program.delete
            ){
                this.page.form.permission.special_program.page = true
            }
            else{
                this.page.form.permission.special_program.page = false
            }

            //Event
            if(
                this.page.form.permission.event.view ||
                this.page.form.permission.event.add ||
                this.page.form.permission.event.edit ||
                this.page.form.permission.event.delete ||
                this.page.form.permission.event.switch
            ){
                this.page.form.permission.event.page = true
            }
            else{
                this.page.form.permission.event.page = false
            }

            //User
            if(
                this.page.form.permission.user.view ||
                this.page.form.permission.user.add ||
                this.page.form.permission.user.edit ||
                this.page.form.permission.user.delete
            ){
                this.page.form.permission.user.page = true
            }
            else{
                this.page.form.permission.user.page = false
            }


            //User Role
            if(
                this.page.form.permission.user_role.view ||
                this.page.form.permission.user_role.add ||
                this.page.form.permission.user_role.edit ||
                this.page.form.permission.user_role.delete
            ){
                this.page.form.permission.user_role.page = true
            }
            else{
                this.page.form.permission.user_role.page = false
            }

            //User Rights
            if(
                this.page.form.permission.user_rights.view ||
                this.page.form.permission.user_rights.edit
            ){
                this.page.form.permission.user_rights.page = true
            }
            else{
                this.page.form.permission.user_rights.page = false
            }
            this.setRights()
        },
        setRights(){
            this.loading = true

            this.$axios.post("user-rights/update.php", {
                id: this.page.form.roleSelection.r_id,
                permission: this.page.form.permission
            }, {
                headers: generateHeader("userRightsUpdate")
            })
            .then((response) => {
                if(response.data.code == "204"){
                    this.$notify.success({
                        title: 'Success',
                        message: response.data.extra.message
                    });
                    this.getData()
                }
                else if (response.data.code == "401"){
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                    localStorage.clear()
                    this.$router.push('/login')
                }
                else{
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                }
                this.loading = false
            })
            .catch((error) => {
                this.$notify.error({
                    title: 'Error',
                    message: error                   
                });
                this.loading = false
            })
        }
    },
    mounted() {
        this.getRights()
    }
}
</script>